<template>
  <div>
    <list :brandList='brandList'></list>
  </div>
</template>
<script>
import list from './components/list'
import { getBrandList } from '@/api'
export default {
  components: {
    list
  },
  data () {
    return {
      brandList: []
    }
  },
  methods: {
    async getBrandList () {
      const result = await getBrandList()
      this.brandList = result.data.data
    }
  },
  created () {
    this.getBrandList()
  }
}
</script>
<style lang="scss" scoped>
</style>
